var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefrigerator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "refrigerator"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.75 0.833496H6.25C4.18225 0.833496 2.5 2.5469 2.5 4.65294V15.3474C2.5 17.4534 4.18225 19.1668 6.25 19.1668H13.75C15.8177 19.1668 17.5 17.4534 17.5 15.3474V4.65294C17.5 2.5469 15.8177 0.833496 13.75 0.833496ZM6.25 2.36127H13.75C14.9905 2.36127 16 3.38947 16 4.65294V7.7085H13.75V5.41683C13.75 4.99516 13.4148 4.65294 13 4.65294C12.5852 4.65294 12.25 4.99516 12.25 5.41683V7.7085H4V4.65294C4 3.38947 5.0095 2.36127 6.25 2.36127ZM13.75 17.639H6.25C5.0095 17.639 4 16.6109 4 15.3474V9.23627H12.25V13.8196C12.25 14.242 12.5852 14.5835 13 14.5835C13.4148 14.5835 13.75 14.242 13.75 13.8196V9.23627H16V15.3474C16 16.6109 14.9905 17.639 13.75 17.639Z",
    fill: "#A273FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefrigerator);
export default __webpack_public_path__ + "static/media/refrigerator.98d23f3ea102c53edd31553a216d3eb7.svg";
export { ForwardRef as ReactComponent };